class Controller {
  constructor($injector) {
    "ngInject";

    this.Events = $injector.get("Events");
    this.routeClickEvent = this.Events.getSelectRouteEvent();
  }

  $onInit() {
    this.clickRoute = (route) => {
      this.Events.emit(this.routeClickEvent, route);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/directionWaypoints/directionWaypoints.controller.js